export default __webpack_public_path__ + "static/media/acknowledgements_img2.bff9b02a.png";